import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { CurrentUser } from '../model/current-user';

@Component({
  selector: 'app-user-info-wrapper',
  templateUrl: './user-info-wrapper.component.html',
  styleUrls: ['./user-info-wrapper.component.css'],
})
export class UserInfoWrapperComponent implements OnInit {
  user: CurrentUser = !!sessionStorage.getItem('CURRENT_USER') ? JSON.parse(sessionStorage.getItem('CURRENT_USER')) : null;
  templeOwner = false;
  @Input() isAccount = false;
  @Output() logout: EventEmitter<string> = new EventEmitter<string>();
  constructor() { }

  ngOnInit() {
    this.user.roles.forEach(element => {
      if (element.name === 'FULL_ACCESS') {
        this.templeOwner = true;
      }
    });
  }
  signOut() {
    this.logout.emit('logout');
  }

}
